import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import InActivityLogoutModal from "../components/InActivityLogoutModal/InActivityLogoutModal";

const InactivityLogoutTimer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [countdown, setCountdown] = useState(60);
  const [showAlert, setShowAlert] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);

  const pathNames =
    location.pathname !== "/" &&
    location.pathname !== "/whyogiso" &&
    location.pathname !== "/pricing" &&
    location.pathname !== "/login" &&
    location.pathname !== "/signup" &&
    location.pathname !== "/term-conditions" &&
    location.pathname !== "/contact-us" &&
    location.pathname !== "/cookies-policy";

  useEffect(() => {
    const checkForInactivity = () => {
      const expireTimeString = localStorage.getItem("expireTime");
      const expireTime = expireTimeString ? parseInt(expireTimeString) : 0;
      if (pathNames && expireTime < Date.now()) {
        if (!showAlert) {
          setShowAlert(true);
        }
      }
    };

    const updateExpiryTime = () => {
      // <----- 30 mins === 1800000 ms, 29 mins = 1740000, 1 min === 60000 ms -----> \\

      const expireTime = Date.now() + 1740000; // -----> Pass above time here to show popup after that amount of time. -----> \\
      localStorage.setItem("expireTime", expireTime.toString());
    };

    const handleActivity = () => {
      updateExpiryTime();
    };

    const events = ["click", "keypress", "scroll", "mousemove"];
    events.forEach((event) => window.addEventListener(event, handleActivity));

    const intervalId = setInterval(checkForInactivity, 5000);
    updateExpiryTime();

    return () => {
      clearInterval(intervalId);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
    };
  }, [location, navigate, showAlert, pathNames]);

  useEffect(() => {
    if (showAlert) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 0) {
            setShowAlert(false);
            clearInterval(timer);
            navigate("/");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [showAlert, navigate]);

  useEffect(() => {
    if (location.pathname === "/") {
      setShowAlert(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!showAlert && countdown >= 0) {
      open();
      setCountdown(60);
    }
  }, [showAlert, countdown]);

  return (
    pathNames &&
    showAlert && (
      <InActivityLogoutModal
        opened={opened}
        close={close}
        setShowAlert={setShowAlert}
        countdown={countdown}
        setCountdown={setCountdown}
        navigate={navigate}
      />
    )
  );
};

export default InactivityLogoutTimer;